// extracted by mini-css-extract-plugin
export default {"container":"style_container__4hXBz","content":"style_content__Tso84","title":"style_title__I9qpu","title_header":"style_title_header__ohfZr","title_inner":"style_title_inner__uhnyc"};